import apiBase from "../../api/axios";

// Obtener el status de confirmación
export const getConfirmacionStatusService = async () => {
  const response = await apiBase.get(
    "v1/confirmacion/confirmacion-talentos/status/"
  );
  return response.data;
};

// Obtener la pregunta actual de confirmación
export const getCurrentConfirmacionService = async () => {
  const response = await apiBase.get(
    "v1/confirmacion/confirmacion-talentos/current/"
  );
  return response.data;
};

// Enviar respuesta de confirmación
export const sendConfirmacionAnswerService = async (payload) => {
  const response = await apiBase.post(
    "v1/confirmacion/confirmacion-talentos/answer/",
    payload
  );
  return response.data;
};

// Obtener mis talentos
export const getMisTalentosService = async () => {
  const response = await apiBase.get("v1/mis-talentos/");
  return response.data;
};

// Obtener talentos confirmados
export const getConfirmacionesCompletadasService = async () => {
  const response = await apiBase.get(
    "v1/confirmacion/confirmacion-talentos/completed/"
  );
  return response.data;
};

// Obtener resumen de confirmaciones
export const getConfirmacionSummaryService = async () => {
  const response = await apiBase.get(
    "v1/confirmacion/confirmacion-talentos/summary/"
  );
  return response.data;
};
